module.exports = __webpack_public_path__ + "img/item-1.143513c4.png";